<template>
  <section
    class="z-10 bg-white absolute top-full overflow-y-auto left-0 right-auto shadow-md max-h-80 custom-scrollbar w-72 mt-2.5"
  >
    <div class="bg-white border-b pb-2.5 px-6 py-4 w-full" @click.stop>
      <div class="relative">
        <Input
          :icon="true"
          input_class="rounded-full"
          :value="query"
          @input="$emit('on-search', $event)"
        />
        <font-awesome-icon
          icon="fa-magnifying-glass"
          class="absolute -translate-y-1/2 top-1/2 left-3 text-primary"
        />
      </div>
      <ul>
        <li
          v-for="(item, index) in items"
          :key="index"
          class="flex items-center justify-between px-4 py-2 text-sm text-gray-400 cursor-pointer hover:bg-primary hover:text-white"
          @click="$emit('on-marked-data', item)"
        >
          {{ item.company_name }}
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import Input from "@/components/Input.vue";
export default {
  name: "ListDropdown",
  components: {
    Input,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    query: {
      type: String,
      default: "",
    },
  },
};
</script>
